import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of } from 'rxjs';
import { PricingApiService } from '../pricing-api.service';
import {
  getFare,
  getFareComplete,
  getReshopFare,
  getReshopFareComplete,
  getFareQuote,
  getFareQuoteComplete,
  getReshopQuoteFare,
  getReshopQuoteFareComplete,
} from './pricing-api.actions';

@Injectable()
export class PricingApiEffects {
  private readonly actions$ = inject(Actions);
  private readonly pricingApiService = inject(PricingApiService);

  getFare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFare),
      mergeMap(({ request, background }) => {
        return this.pricingApiService.getPricingApiFare(request, background).pipe(
          map((response) => getFareComplete({ request, response })),
          catchError((error) =>
            of(
              getFareComplete({
                request,
                response: {
                  success: false,
                  exceptionContent: error.error?.exceptionContent ?? 'Uncaught',
                  response: null,
                },
              })
            )
          )
        );
      })
    )
  );

  getReshopFare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getReshopFare),
      mergeMap(({ request, background }) => {
        return this.pricingApiService.getReshopFare(request, background).pipe(
          map((response) => getReshopFareComplete({ request, response })),
          catchError((error) =>
            of(
              getReshopFareComplete({
                request,
                response: {
                  success: false,
                  exceptionContent: error.error?.exceptionContent ?? 'Uncaught',
                  response: null,
                },
              })
            )
          )
        );
      })
    )
  );

  getFareQuote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFareQuote),
      mergeMap(({ request, background }) => {
        return this.pricingApiService.getFareQuote(request, background).pipe(
          map((response) => getFareQuoteComplete({ request, response })),
          catchError((error) =>
            of(
              getFareQuoteComplete({
                request,
                response: {
                  success: false,
                  exceptionContent: error.error?.exceptionContent ?? 'Uncaught',
                  response: null,
                },
              })
            )
          )
        );
      })
    )
  );
  getReshopQuoteFare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getReshopQuoteFare),
      mergeMap(({ request, background }) => {
        return this.pricingApiService.getReshopQuoteFare(request, background).pipe(
          map((response) => getReshopQuoteFareComplete({ request, response })),
          catchError((error) =>
            of(
              getReshopQuoteFareComplete({
                request,
                response: {
                  success: false,
                  exceptionContent: error.error?.exceptionContent ?? 'Uncaught',
                  response: null,
                },
              })
            )
          )
        );
      })
    )
  );
}
